var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({},'v-btn',{ ..._vm.$attrs, ..._vm.baseAttrs },false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v("Back")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }